export const pageSearch = {
  'wantCode': {
    title: '要货单号',
    type: 'input'
  },
  'customerCode': {
    title: '客户编码',
    type: 'dialog',
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    }
  },
  'createdDate': {
    title: '申请取消时间',
    type: 'date',
    valueFormat: 'yyyy-MM-dd'
  }
}

export default {
  'createdDate': {
    title: '申请取消日期',
    width: 140
  },
  'billStatus': {
    title: '单据状态',
    width: 100
  },
  'cancelFlag': {
    title: '允许退货',
    width: 100,
    formatter: ({ cellValue }) => cellValue == 1 ? '允许' : '不允许'
  },
  'wantCode': {
    title: '要货单号',
    width: 110
  },
  'comment': {
     title: '取消原因',
     width: 180
   },
  // 'feedback': {
  //   title: '安吉反馈信息',
  //  width: 140
   //},
  'customerCode': {
    title: '客户编码',
    width: 110
  },
  'customerName': {
    title: '客户名称',
    width: 120
  },
  'wantDate': {
    title: '要货申请时间',
    width: 140
  },
  'productDesc': {
    title: '产品描述',
    width: 150
  },
  'receiveAddress': {
    title: '收货地址',
    width: 250
  },
  'wantQuantity': {
    title: '要货数量',
    width: 100
  },
  'partner': {
    title: '创建人编码',
    width: 130
  },
  'createdByName': {
    title: '创建人名称',
    width: 120
  }
}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/deliveryCancelSearch.js